// CANONICAL COPY (GH #7115). src/constants/obligations/obl-environment-separation.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-environment-separation',
  title: 'Verify separation of development, test and production environments',
  description:
    'Confirm that development, testing and production environments are separated and independently controlled to reduce the risks of unauthorised access or changes to the production environment. Access, data, credentials and change processes shall be distinct across environments; sensitive production data shall not be used in lower environments without appropriate protection (masking, pseudonymisation or equivalent).',
  category: 'technical',
  scfIds: ['SCF-DEV-007'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Environment separation standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
